Ext.ns('mx.comp');

mx.comp.LinkedBoxSelect = Ext.extend(Ext.ux.form.SuperBoxSelect, {
    setValue: function(value) {
        if (!this.rendered) {
            this.preRenderValue = value;
            return;
        }

        if (!value) {
            return;
        }

        var values = Ext.isArray(value) ? value : value.split(this.valueDelimiter);
        this.removeAllItems().resetStore();

        this.remoteLookup = [];

        Ext.each(
            values,
            function(val) {
                this.addRecord(val);
            },
            this
        );
    },

    getValue: function() {
        var items = [];
        this.usedRecords.each(function(i) {
            items.push(i);
        });
        return items;
    },
});
